import { addMinutes, format } from 'date-fns';
import { es } from 'date-fns/esm/locale';
import { utils } from 'xlsx';

export function classNames(...classes: Array<string | undefined>) {
  return classes.filter(Boolean).join(' ');
}

export function formatDate(
  dateString: Date,
  formatString = `do 'de' MMMM 'del' yyyy`,
  isUTC = true
) {
  if (!dateString) return '-';
  const date = new Date(dateString);
  return format(isUTC ? addMinutes(date, date.getTimezoneOffset()) : date, formatString, {
    locale: es,
  });
}

export function scrollToTop() {
  document?.querySelector('#scroller')?.scrollTo({
    top: 0,
    behavior: 'smooth',
  });
}

export const cleanObject = (params: any, onlyNull = false) => {
  Object.keys(params).map((key) => {
    if (onlyNull) {
      if (params[key] === null) delete params[key];
    } else {
      if (!params[key]) delete params[key];
    }
    return key;
  });
  return params;
};

export const sheetToArray = (sheet: any) => {
  let result = [],
    row,
    rowNum,
    colNum;

  let range = utils.decode_range(sheet['!ref']);
  for (rowNum = range.s.r; rowNum <= range.e.r; rowNum++) {
    row = [];
    for (colNum = range.s.c; colNum <= range.e.c; colNum++) {
      let nextCell = sheet[utils.encode_cell({ r: rowNum, c: colNum })];
      if (typeof nextCell === 'undefined') {
        row.push(void 0);
      } else row.push(nextCell.w);
    }
    result.push(row);
  }
  return result;
};
